import { render, staticRenderFns } from "./CallsList.vue?vue&type=template&id=29632948&scoped=true&lang=pug"
import script from "./CallsList.vue?vue&type=script&lang=js"
export * from "./CallsList.vue?vue&type=script&lang=js"
import style0 from "./CallsList.vue?vue&type=style&index=0&id=29632948&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29632948",
  null
  
)

export default component.exports